import React from "react";
var __jsx = React.createElement;
import stl from "./Loaderv2.module.css";
var Loader = function Loader(_ref) {
  var _ref$smallLoader = _ref.smallLoader,
    smallLoader = _ref$smallLoader === void 0 ? false : _ref$smallLoader,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.loadContainer, smallLoader ? stl.smallLoader : "", className ? className : ""].join(" ")
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }));
};
export default Loader;